<mat-nav-list>
    <h4>Config Actions for {{data?.language?.name}}</h4>
    <a *ngIf="data?.language?.status == DraftStatus.EDITING" mat-list-item (click)="gotoConfigEditor($event)">
        <span mat-line>Edit Config</span>
    </a>
    <a *ngIf="data?.language?.status == DraftStatus.EDITING" mat-list-item (click)="gotoLessonEditor($event)">
        <span mat-line>Edit Lessons</span>
    </a>
    <a *ngIf="data?.language?.status == DraftStatus.EDITING" mat-list-item (click)="submit($event)">
        <span mat-line>Submit for Review</span>
    </a>
    <a *ngIf="data?.language?.status == DraftStatus.IN_REVIEW && data.isAdmin" mat-list-item (click)="publish($event)">
        <span mat-line>Approve and Publish</span>
    </a>

</mat-nav-list>